import { some, trim, toLower, isEmpty, values, includes } from "lodash";
export default function isMatchingAccount(account, query) {
  if (isEmpty(trim(query))) {
    return true;
  }
  return some(values(account), val =>
    includes(toLower(trim(val)), toLower(trim(query)))
  );
}
